import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconCloseCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M7.999 1.333c-3.687 0-6.667 2.98-6.667 6.667s2.98 6.667 6.667 6.667c3.686 0 6.666-2.98 6.666-6.667S11.685 1.333 8 1.333zm3.333 9.06l-.94.94L7.999 8.94l-2.394 2.393-.94-.94L7.06 8 4.665 5.607l.94-.94L8 7.06l2.393-2.393.94.94L8.939 8l2.393 2.393z"
	})
});
export default SvgIconCloseCircle;
